import { ChangeDetectionStrategy, Component, inject, Injector, OnInit, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MiniApps } from '../../../shared/models/mini-app.model';
import { Breadcrumb } from '../../../store/models';
import { AppService } from '../../../store/services';
import { CitationResponse } from '../../../store/models/citation.model';
import { CitationsTileComponent } from '../../components/citations-tile/citations-tile.component';
import { BreadcrumbComponent } from '../../../shared/containers/breadcrumb/breadcrumb.component';
import { TopNavComponent } from '../../../shared/containers/top-nav/top-nav.component';

@Component({
  selector: 'gnx-citations-page',
  templateUrl: './citations-page.component.html',
  styleUrls: ['./citations-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TopNavComponent, BreadcrumbComponent, CitationsTileComponent],
})
export class CitationsPageComponent implements OnInit {
  appService = inject(AppService);

  MiniApps = MiniApps;
  crumbs: Breadcrumb[];

  citationsResponse: Signal<CitationResponse | undefined>;

  private injector = inject(Injector);

  ngOnInit(): void {
    this.crumbs = [
      {
        name: 'Search page',
        route: '/',
      },
      {
        name: 'Franklin Mentions',
        route: '/citations',
      },
    ];
    this.citationsResponse = toSignal(this.appService.getCitations(), {
      initialValue: undefined,
      injector: this.injector,
    });
  }
}
